export default "__VITE_ASSET__afc041ae__"